const rankingItems = [
  { rank: 1, title: '某顶流男星绯闻女友身份实锤', heat: '3,421万', trend: 'hot', change: '+3' },
  { rank: 2, title: '千万粉博主直播翻车全程', heat: '2,058万', trend: 'up', change: '+5' },
  { rank: 3, title: '网红情侣分手互撕大戏', heat: '1,876万', trend: 'up', change: '+2' },
  { rank: 4, title: '选秀冠军学历造假疑云', heat: '1,542万', trend: 'new', change: 'NEW' },
  { rank: 5, title: '健身博主人设崩塌实录', heat: '1,286万', trend: 'up', change: '+8' },
  { rank: 6, title: '知名导演被曝潜规则事件', heat: '987万', trend: 'stable', change: '-' },
  { rank: 7, title: '短视频顶流突然宣布停更', heat: '892万', trend: 'down', change: '-2' },
];

const trendConfig: Record<string, { icon: string; color: string }> = {
  hot: { icon: 'ri-fire-line', color: 'text-primary-500' },
  up: { icon: 'ri-arrow-up-line', color: 'text-primary-500' },
  new: { icon: 'ri-sparkling-line', color: 'text-accent-500' },
  stable: { icon: 'ri-subtract-line', color: 'text-foreground-400' },
  down: { icon: 'ri-arrow-down-line', color: 'text-foreground-400' },
};

export default function Ranking() {
  return (
    <section id="ranking" className="w-full py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-accent-500"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
            热搜榜单
          </h2>
          <span className="text-xs text-foreground-400 bg-background-200 px-2 py-0.5 rounded-full whitespace-nowrap">
            Top 7
          </span>
        </div>
        <div className="bg-background-100 rounded-2xl border border-background-200/70 overflow-hidden">
          {rankingItems.map((item, i) => (
            <a
              key={item.rank}
              href="#"
              className={`flex items-center gap-4 px-5 py-4 hover:bg-background-50 transition-colors duration-150 cursor-pointer ${
                i < rankingItems.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
            >
              <div
                className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold flex-shrink-0 ${
                  item.rank === 1
                    ? 'bg-primary-500 text-white'
                    : item.rank === 2
                    ? 'bg-primary-300 text-primary-800'
                    : item.rank === 3
                    ? 'bg-accent-300 text-accent-800'
                    : 'bg-background-200 text-foreground-500'
                }`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-800 truncate">
                  {item.title}
                </h3>
              </div>
              <div className="flex items-center gap-3 flex-shrink-0">
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className={`${trendConfig[item.trend].icon} ${trendConfig[item.trend].color} text-xs`}></i>
                  <span className="whitespace-nowrap">{item.heat}</span>
                </div>
                <span
                  className={`text-xs font-medium whitespace-nowrap ${
                    item.change === 'NEW'
                      ? 'text-accent-500'
                      : item.change.startsWith('+')
                      ? 'text-primary-500'
                      : item.change === '-'
                      ? 'text-foreground-400'
                      : 'text-foreground-400'
                  }`}
                >
                  {item.change}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}